import moduleName from './constants';

const getToastsState = (state) => state[moduleName];

export const getToasts = (state) => getToastsState(state).toasts;